var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.pages),function(page){return _c('div',{key:page,ref:"pageContainer",refInFor:true,style:({
      borderBottom: '1px solid #DFDFDF',
      height: _vm.pageHeight + 'px'
    })},[(_vm.renderList.includes(page))?_c('canvas'):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-15a68fb5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/bbsPdf.vue
// module id = null
// module chunks = 